import { useState } from 'react';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle } from '@eo/shared';

import { ProviderConnectForm } from './ProviderConnectForm';
import type { IntegrationDescriptor, AddIntegrationDialogProps } from './types';

export function AddIntegrationDialog({
  open,
  onOpenChange,
  available,
  statusOf,
  onSaveToken,
}: AddIntegrationDialogProps) {
  const [chosen, setChosen] = useState<IntegrationDescriptor | null>(null);

  const close = (next: boolean) => {
    if (!next) setChosen(null);
    onOpenChange(next);
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{chosen ? `Connect ${chosen.title}` : 'Add integration'}</DialogTitle>
        </DialogHeader>

        {chosen ? (
          <div className="flex flex-col gap-4">
            <Button
              variant="ghost"
              className="w-fit px-0 text-text-tertiary hover:text-text-primary"
              onClick={() => setChosen(null)}
            >
              <ArrowLeft className="size-4" />
              All integrations
            </Button>
            <ProviderConnectForm
              descriptor={chosen}
              status={statusOf(chosen.key)}
              onSaveToken={(token) => onSaveToken(chosen.key, token)}
              onDone={() => close(false)}
            />
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            {available.map((descriptor) => (
              <button
                key={descriptor.key}
                type="button"
                onClick={() => setChosen(descriptor)}
                className="flex cursor-pointer items-center justify-between gap-4 rounded-8 border border-border-faint p-4 text-left transition-colors hover:bg-muted focus-visible:border-focus focus-visible:outline-none"
              >
                <span className="flex min-w-0 flex-col">
                  <span className="text-sm text-text-primary">{descriptor.title}</span>
                  <span className="truncate text-xs text-text-tertiary">{descriptor.purpose}</span>
                </span>
                <ChevronRight className="size-4 shrink-0 text-text-tertiary" aria-hidden="true" />
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
